import { handleActions } from 'redux-actions'

import { FetchStatus } from '@tabeeb/enums'
import * as rawActions from '../actions'

const initialState = {
  requireRefetch: false,
  deleteStatus: FetchStatus.Idle,
  items: [],
}

export default handleActions(
  {
    [rawActions.setPowerBIReportTenantsRefetch]: (state, action) => {
      return { ...state, requireRefetch: action.payload }
    },
    [rawActions.getPowerBIReportTenants.success]: (state, action) => {
      return { ...state, items: action.response.data }
    },
    [rawActions.deletePowerBIReportTenant.request]: (state, _action) => {
      return { ...state, deleteStatus: FetchStatus.Loading }
    },
    [rawActions.deletePowerBIReportTenant.failed]: (state, _action) => {
      return { ...state, deleteStatus: FetchStatus.Failed }
    },
    [rawActions.deletePowerBIReportTenant.success]: (state, action) => {
      const newItems = state.items.filter((item) => item.Id !== action.response.data)
      return { ...state, deleteStatus: FetchStatus.Loaded, items: newItems }
    },
  },
  initialState
)
